<template>
  <b-form-group
    :label="name"
    label-class="pb-0"
    class="mb-2"
  >
    <b-input-group>
      <b-input
        v-model="scaleFactor"
        type="number"
        :min="min"
        :step="step"
      />
      <b-input
        v-model="scaleFactor"
        :disabled="scaleFactor > max"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        class="px-0"
      />
    </b-input-group>
  </b-form-group>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Path } from '@/types'

import { NODE_CONFIG_KEY } from '@/constants'

const props = {
  path: {
    type: Path,
    required: true,
  },
}

@Component
export default class ScaleFactorTab extends Vue.extend({ props }) {
  min = 0 // would prefer min = 1 but causes unusual behaviour when combined with step
  max = 1000

  get step () {
    return this.getStepSize(this.scaleFactor)
  }

  get name () {
    return this.path.name + ':'
  }

  get scaleFactor () {
    return this.$typedStore.primary.entities.nodes.scaleFactor(this.path)
  }

  set scaleFactor (value) {
    if (value < 1) value = 1 // enforce min of 1
    this.$typedStore.primary.entities.nodes.updateNodeProp({
      path: this.path.toString(),
      configPath: [NODE_CONFIG_KEY, 'scaleFactor'],
      value: Number(value),
    })
  }

  getStepSize (number: number) {
    return Math.pow(10, Math.ceil(Math.log10(number + 1)) - 1)
  }
}
</script>
